import React from 'react';

const SilentCallback: React.FC = () => {
  React.useEffect(() => {
    // Silent renew callback wird automatisch von oidc-client-ts verarbeitet
  }, []);

  return <div>Silent authentication in progress...</div>;
};

export default SilentCallback;
